<template>
<div v-show="kpi"  v-bind:class="{ pihead1: isHeader && showInlineYtd, pihead2: isHeader && !showInlineYtd && !isStandalone, piheadtop: isStandalone }">
  <div class="pihead" v-bind:class="{ pigrid: isStandalone}">
    <div>
      <table class="kpitable">
        <tr>
          <td class="kpicol-small"
              v-bind:style="{ 'width': getMinorItemWidth(minorWaveCount) + '%', }"
              v-for="index in minorWaveCount"
              v-bind:class="getBackgroundClass(index)"
              v-bind:key="index">
            <div class="perf-cell">
              <div class="perf-block">
                <div class="perf-head" v-bind:class="{ narrow: isNarrow(index) }">{{ getSlotName(index) }}</div>
                <div class="perf-value">{{ getSlotValue(index) }}</div>
              </div>
            </div>
          </td>
          <td class="kpicol-large"
            v-bind:style="{ 'width': getMajorItemWidth(minorWaveCount) + '%', }"
              v-bind:class="getBackgroundClass(101)">
            <div class="container2">
              <div class="perf-head left" v-bind:class="{ narrow: isNarrow(101) }">{{ getSlotName(101) }}</div>
              <div class="bc-highlight">{{ getSlotValue(101) }}</div>
              <div class="image">
                <span href="#" class="black" >
                  <font-awesome-icon v-if="getArrow === 2" icon="arrow-up" item-width="24" item-height="36" />
                  <font-awesome-icon v-if="getArrow === 3" icon="arrow-down" item-width="24" item-height="36" />
                  <font-awesome-icon v-if="getArrow === 1" icon="arrow-right" item-width="24" item-height="36" />
                </span>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div v-show="showInlineYtd && hasYtdValue(kpi)">
      <div style="height: 100%; top: 0px; font-size:small; margin-left:4px; color: #eee; text-align: center;">YTD: {{ getYtdValue(kpi).Result }}</div>
      <div>&nbsp;</div>
    </div>

  </div>
</div>
</template>

<script>

  import ytdMixin from '@/mixins/YearToDateMixin.js';
  import PerformanceItemMixin from '@/mixins/bmw/PerformanceItemMixin.js';

  export default {
    mixins: [ ytdMixin, PerformanceItemMixin ],

    methods:{
      getOtherClass: function (slot){
        return '{ width: 25%; }';
      },

      getBackgroundForIndicator: function (index) {
        if (this.monochrome) {
          return {'bc-gray' : true}
        }

        if (index === null) {
          return  {'bc-red' : true}
        }

        if (this.kpi === null || this.kpi.SurveyWave === null ) {
          return {'bc-gray' : true}
        }

        if (this.isBMWMoto) {
          if (this.kpi.SurveyWave[index].Result < 60) {
            return { 'bc-red': true }
          }
          else if (this.kpi.SurveyWave[index].Result < 80) {
            return  {'bc-yellow' : true}
          }
          else {
            return  {'bc-green' : true}
          }
        } else {
          if (this.isLostLead) {
            if (this.kpi.SurveyWave[index].Result < 5) {
              return { 'bc-green': true }
            }
            else if (this.kpi.SurveyWave[index].Result < 10) {
              return  {'bc-yellow' : true}
            }
            else {
              return  {'bc-red' : true}
            }
          } else {
            if (this.kpi.SurveyWave[index].Result < 90) {
              return { 'bc-red': true }
            }
            else if (this.kpi.SurveyWave[index].Result < 100) {
              return  {'bc-yellow' : true}
            }
            else {
              return  {'bc-green' : true}
            }
          }
        }
      }
    }
  }

</script>


<style lang="scss" scoped>
  @use "@/../scss/bmw/performanceitem.scss";

  .perf-cell {
    display: grid;
    margin: 0px;
    padding: 0px;
  }

  .perf-block{
    display: grid;
    height: 32px;
    margin: 0px;
    padding: 0px;
  }

  .perf-head {
    display: grid;
    position: relative;
    margin: 0px;
    padding: 0px;
  }

  .perf-value {
    display: grid;
    position: relative;
    height: 50%;
  }

  .image {
    top: -30px;
    right: -36px;
  }

  .container2 {
    display: flex;
    margin: 0px;
    padding: 0px;
    display: inline-block;
    *display: inline;
    vertical-align: top;
    height: 32px;
  }

  .bc-cell {
    float: left;
    text-overflow: ellipsis;
    margin: 0;
    padding: 0;
    display: table-cell;
  }

  .kpicol-small{
    width: 16.666%;
  }

  .kpicol-large {
    width: 50%;
  }

  .kpitable{
    height: auto;
    width:100%;
  }

  .card-body {
    padding: 0pt;
  }

  .bc-header {
    padding: 0pt;
    margin: 0pt;
    align-self: auto;
  }

  .card-header {
    padding: 0pt;
    margin: 0pt;
    align-self: auto;
  }

  .table {
    padding: 0pt;
    margin: 0pt;
  }

</style>
